import React from 'react';
import { useMutation } from 'react-query';
import { Trans } from 'react-i18next';
import { useRequest } from '@datahub/api-client';
import { DataSourceMutationPropsInterface } from './DataSourceMutationProps.interface';
import { ApiOperation } from '../../../api';
import useDataSourceNotFoundErrorHandler from '../../error-handlers/data-source/useDataSourceNotFoundError.handler';
import useGeneralErrorHandler from '../../error-handlers/useGeneralErrorHandler';
import useOnError from '../../error-handlers/useOnError';
import { syncDataSourceMutationKey } from '../mutationKeys';
import { useAlert } from '../../../alert/Alert.provider';
import { DataSourceInterface } from '../../../../types/data-source/DataSource.interface';

const useSyncDataSourceMutation = ({ setOtherError }: DataSourceMutationPropsInterface = {}) => {
  const { showAlert } = useAlert();

  const { request } = useRequest(ApiOperation.SyncDataSource);

  const notFoundErrorHandler = useDataSourceNotFoundErrorHandler(setOtherError);
  const generalErrorHandler = useGeneralErrorHandler(setOtherError);

  const { onError } = useOnError([notFoundErrorHandler], generalErrorHandler);

  return useMutation(
    async ({ uniqueNumber }: DataSourceInterface) => {
      const res = await request({ urlParams: { id: uniqueNumber } });

      return res.data;
    },
    {
      mutationKey: syncDataSourceMutationKey,
      onSuccess: (_, { name }: DataSourceInterface) => {
        showAlert(
          <Trans
            i18nKey="dataSourcesSettings.sections.dataSources.subsections.supplierList.actions.sync.success"
            values={{ name }}
            components={{ bold: <strong /> }}
          />,
          'success',
        );
      },
      onError,
    },
  );
};

export default useSyncDataSourceMutation;
